const sortBy = require('lodash.sortby');
const remove = require('lodash.remove');
import $tools from '@/common'; 
import moment from "moment";
let defaultCoins = ['C2C', 'QC', 'CNY', 'CNYT'];
import {
    BigNumber
} from 'bignumber.js'

// 将科学计数法转字符串
function toNonExponential(num) {
    if (!num || isNaN(num)) return num;
    if (!isNaN(Number(num))) {
        num = Number(num);
    };

    var m = num.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/);
    return num.toFixed(Math.max(0, (m[1] || '').length - m[2]));
}

export default {
    // getJsonData(localStorage.tickers, {})
    getJsonData: function (str, value = {}) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return value;
        }
    },
    //获取数量精确度
    getAutoNumber: function (n) {
        n = Math.abs(n);
        if (n == 0) return 0;
        // if (this >= 10) return 2;
        // if (this >= 1) return 3;
        if (n >= 0.1) return 3;
        if (n >= 0.01) return 4;
        if (n > 0.001) return 6;
        return 8;
    },
    autoNumber: function (n, len) {
        if (n == '--') return n;
        return autoFixed(n);
        // var number = common.toNumber(n);
        // var str = new BigNumber(number).toString().split('.')[1];
        // var n = common.getAutoNumber(number);
        // if (str && str.length > n) n = str.length;
        // return common.toFixedEx(number, len || n);
    },
    //字符转成数字类型
    toNumber: function (str, len) {
        len = len || 8;
        var n = parseFloat(str);
        if (isNaN(n) || Math.abs(n) == Infinity)
            return 0;
        n = parseFloat(this.toFixedEx(n, len));
        if (n == 0)
            return Math.abs(n);
        return n * 1.0;
    },
    // toFixedEx: function (n, len) {
    //     if (typeof len == 'undefined') len = 8;
    //     var str = parseFloat(new BigNumber(n)).toFixed(9);
    //     var re = eval("/(\\.\\d{" + len + "})\\d+$/");
    //     return str.replace(re, "$1");
    //     // return new BigNumber(n).toFixed(len);
    // },
    toFixedEx: function (n, len) {

        if (!n) return 0;
        if (n == NaN) return 0;
        if (n == Infinity) return 0;
        if (typeof len == 'undefined') len = 8;

        n = toNonExponential(n);
        var re = eval("/(\\.\\d{" + len + "})\\d+$/");
        return (n + '').replace(re, "$1");
    },

    autoFixed: function (n, len) {
        if (!len) len = this.getAutoNumber(n);

        // n.replace(reg,'')
        // console.log(n,len);
        return this.toFixedEx(n, len);
    },
    //排序 [{price:3}, {price:2}, {price:4}]
    sortBy(data, callback) {
        return sortBy(data, callback);
    },
    //var a = clone(ab)
    //ab = {ab:1}
    clone: function (obj) {
        var o;
        if (typeof obj == "object") {
            if (obj === null) {
                o = null;
            } else {
                if (obj instanceof Array) {
                    o = [];
                    for (var i = 0, len = obj.length; i < len; i++) {
                        o.push(this.clone(obj[i]));
                    }
                } else {
                    o = {};
                    for (var j in obj) {
                        o[j] = this.clone(obj[j]);
                    }
                }
            }
        } else {
            o = obj;
        }
        return o;
    },
    //从数组中删除 数据
    //remove([1,2,4], 4)
    remove(a, b) {
        return remove(a, b);
    },
    /**
     * 1. coins="BTC" data=0.01
     * 2. coins = {
     *    BTC: 0.01,
     *    ETH: 1
     * }
     */
    setPrices: function () {
        var tickers = [];
        var tickersList = JSON.parse(localStorage.getItem('tickers')) || {};

        for (let item in tickersList) {
            tickersList[item]['market'] = item;
            tickers.push(tickersList[item]);
        }

        var lastPrices = {};
        var baseCoins = [];
        for (var item of tickers) {
            lastPrices[item.market] = item.last;
            if (item.market) {
                let baseCoin = this.getBaseCoin(item.market);
                if (baseCoins.indexOf(baseCoin) == -1) {
                    baseCoins.push(this.getBaseCoin(item.market));
                }
            }
        }
        let price = {}
        //排除掉与人民币价格为1：1的币
        let noExit = [];
        for (let bs of baseCoins) {
            if (defaultCoins.indexOf(bs) != -1) {
                price[bs] = 1;
            } else {
                noExit.push(bs);
                price[bs] = 0;
            }
        }
        //求出与人民币为1:1的值
        for (let base of noExit) {
            for (let b of defaultCoins) {
                if (lastPrices[base + '_' + b]) {
                    price[base] = parseFloat(lastPrices[base + '_' + b]);
                    break;
                }
            }
        }
        // console.log(price)
        localStorage.setItem('prices', JSON.stringify(price) || {});
    },
    toCNY(market, balance) {
        if (!market || !balance || market.indexOf('--') != -1) {
            return 0;
        }
        this.setPrices();

        balance = parseFloat(balance);
        let price = 0;
        if (market.indexOf('_') == -1 && market.indexOf('/') == -1) { //单个币种
            var tickers = [];
            var tickersList = JSON.parse(localStorage.getItem('tickers')) || {};

            for (let item in tickersList) {
                tickersList[item]['market'] = item;
                tickers.push(tickersList[item]);
            }

            let marketNew = '';
            let last = 0;
            for (let base of defaultCoins) { //['C2C', 'QC', 'CNY', 'CNYT']
                if (market == base) {
                    return balance;
                }
                marketNew = market + '_' + base;
                for (let item of tickers) {
                    if (item.market == marketNew) {
                        last = item.last;
                        break;
                    }
                }
                if (last) break;
            }
            return this.toCNY(marketNew, parseFloat(last) * balance);
        } else {
            var prices = $tools.cache.getPrices();
            let base = this.getBaseCoin(market);
            if (base && prices && prices[base]) price = prices[base];
        }
        return this.toNumber(parseFloat(price) * balance);
    },
    toCNYs: function (datas) {
        console.log(datas)
        var balance = 0;
        for (var pair in datas) {
            balance += this.toCNY(pair, datas[pair]);
        }
        return balance;
    },
    toC2C: function (coins, data, len) {
        var lastPrices = JSON.parse(localStorage.lastPrices || '{}') || {};
        var tempData = {};
        if (typeof coins == 'string') {
            tempData[coins] = data;
        } else
            tempData = coins;
        var value = 0;
        for (var coin in tempData) {
            var price = lastPrices['C2C_' + coin] || lastPrices['CNN_' + coin] || 0;
            if (price == 0) {
                if (coin == 'C2C' || coin == 'CNN') {
                    price = 1;
                } else if (coin == 'BTC')
                    price = localStorage.btcPrice;
                else
                    price = lastPrices['BTC_' + coin] * localStorage.btcPrice;
            }
            value += this.toNumber(tempData[coin] * price)
        }
        return value
    },
    //ETH/BTC  转成交易对 ETH_BTC
    getPair: function (str) {
        if (!str) return;
        var arr = str.split('/')
        var oldStr = arr[1] + '_' + arr[0]
        return oldStr
    },
    toString: function (str) {
        if (!str) return;
        var arr = str.split('_')
        var newStr = arr[0] + '/' + arr[1]
        return newStr
    },
    //获取 主币种
    getBaseCoin: function (str) {
        if (!str) return;
        let arry = str.split('/');
        if (arry.length > 1) {
            return arry[1];
        } else {
            arry = str.split('_');
            return arry[1];
        }
    },
    //获取交易币种
    getCoin: function (str) {
        if (!str) return;
        let arry = str.split('/');
        if (arry.length > 1) {
            return arry[1];
        } else {
            arry = str.split('_');
            return arry[0];
        }
    },
    //获取币符号
    getSymbol: function (coin) {
        if (coin == 'BTC') {
            return '฿';
        } else if (coin == 'USDT') {
            return '$';
        } else if (coin == 'CNY') {
            return '￥';
        } else return coin;
    },
    //默认的交易市场
    getDefaultMarket() {
        let tickers = this.getJsonData(localStorage.tickers);
        try {
            return sortBy(tickers, function (item) {
                return -item.baseVol;
            })[0].pair;
        } catch (e) {
            return '';
        }
    },
    //传交易对(BTC_ILK)获取最后的价格
    lastPrice(pair) {
        let tickers = this.getJsonData(localStorage.tickers);
        try {
            return tickers[pair].last;
        } catch (e) {
            return 0;
        }
    },
    //通过交易对获取行情信息
    getTicker(pair, value) {
        let tickers = this.getJsonData(localStorage.tickers, value);
        try {
            return tickers[pair] || value;
        } catch (e) {
            return {};
        }
    },
    //估值
    estimate(n) {
        if (n > 10000) {
            return this.autoFixed(n / 10000) + '万';
        } else {
            return this.toFixedEx(n, 2);
        }
    },
   
    // 日期加时间
    toTimeStr(val) { 
        if (!val) return ' -- : -- ';
        if (typeof val == 'string') {
            let dateformat = function(date, format = 'YYYY-MM-DD HH:mm:ss') {
                return moment(date).format(format)
            } 
            return dateformat(val);
        } else {
            let date = new Date(val * 1000);

            let padDate = function (va) {
                return va < 10 ? '0' + va : va;
            };
            let month = padDate(date.getMonth() + 1);
            let day = padDate(date.getDate());
            let hour = padDate(date.getHours());
            let minutes = padDate(date.getMinutes());
            let seconds = padDate(date.getSeconds());

            return date.getFullYear() + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds;
        }
    },
    // 日期
    toDate(val) {
        var date = new Date(val * 1000);
        let padDate = function (va) {
            return va < 10 ? '0' + va : va;
        };
        return padDate(date.getMonth() + 1) + '-' + padDate(date.getDate());
    },
    getDictValue(data, item, def = "--") {
        let items = item.split(".");
        try {
            for (let item of items) {
                data = data[item]
            }
            return data || def;
        } catch (e) {
            return def;
        }
    }
}


// WEBPACK FOOTER //
// ./src/filters/index.js